<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_645_5489)">
                        <path d="M30.478 18.7855L21.0745 2.09517C20.3377 0.78125 19.0044 0 17.4956 0C15.9868 0 14.6535 0.78125 13.9167 2.09517L4.54832 18.7855C3.81148 20.0994 3.81148 21.6264 4.58341 22.9403C5.32024 24.2543 6.65357 25 8.12725 25H26.8991C28.3727 25 29.7061 24.2188 30.4429 22.9403C31.1797 21.6619 31.1797 20.0994 30.478 18.7855ZM18.2325 19.9574C18.2325 20.4545 17.8465 20.8452 17.3553 20.8452C16.864 20.8452 16.4781 20.4545 16.4781 19.9574V18.5369C16.4781 18.0398 16.864 17.6491 17.3553 17.6491C17.8465 17.6491 18.2325 18.0398 18.2325 18.5369V19.9574ZM18.2325 15.696C18.2325 16.1932 17.8465 16.5838 17.3553 16.5838C16.864 16.5838 16.4781 16.1932 16.4781 15.696V8.23864C16.4781 7.74148 16.864 7.35085 17.3553 7.35085C17.8465 7.35085 18.2325 7.74148 18.2325 8.23864V15.696Z" fill="#265D91"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_645_5489" x="0" y="0" width="35" height="33" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_645_5489"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_645_5489" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                        
                        Alerte
                </h1>

                <!--begin::Menu-->
              
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a href="/accueil" class="text-muted text-hover-primary">Accueil</a>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Alerte</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Autres</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->
        
          <div class="card-body tools">
           <div class="title mb-15">
            <h4>Autres </h4>
           </div>
          <div class="container">
            <div class="row mb-3">
                <div class="col-lg-4">
                    <form class="w-100 position-relative" autocomplete="off">
                        <!--begin::Icon-->
                        <i class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                            <span class="path1"></span>
                            <span class="path2"></span>
                        </i>
                        <!--end::Icon-->
                        <!--begin::Input-->
                        <input type="text" class="form-control form-control-solid search px-13" name="search" value="" placeholder="Rechercher " />
                        <!--end::Input-->
                    </form>
                </div>
                <div class="col-lg-3 rechercher">  
                          </div> 
                <div class="col-lg-4">
                   
                   
                </div>
               
            </div>
         
            <div class="table-responsive mt-15">
                <table class="table align-middle fs-6 gy-5 table-style" id="list_cra">
                    <thead>
                        <th class="bg1 min-w-125px">
                            Alerte
                        </th>
                        <th class="bg2 min-w-125px">
                            Date de l'offre
                        </th>
                        <th class="bg3 min-w-105px">
                            Description
                        </th>
                        <th class="bg4 min-w-125px">
                            Action
                        </th>
                    </thead>
                 <tbody>
                    <tr>
                        <td><span class="alert">Alerte 1</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                    <tr>
                        <td><span class="alert">Alerte 2</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                    <tr>
                        <td><span class="alert">Alerte 3</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                    <tr>
                        <td><span class="alert">Alerte 4</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                    <tr>
                        <td><span class="alert">Alerte 5</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                    <tr>
                        <td><span class="alert">Alerte 6</span></td>
                    <td>
                        <span> 12/05/2023</span>
                    </td>
                    <td>
                        <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor olore magna aliqua. </span>
                    </td>
                    <td>
                        <a href="#" class="voir">Voir plus</a>
                    </td>
                    </tr>
                   
                 </tbody>
    
                </table>
             </div>
          
          
          </div>
        
           
          </div>
        </div>
     
    </div>
    <!--end::Content container-->
</div>

